export default class Answer {
  constructor(data) {
    this.id = data.id || "";
    this.answer = data.answer || "";
    this.likes = data.likes || 0;

    this.responderID = data.responder_id || "";
    this.responderName = data.responder_name || "";
    this.responderSpecifics = data.responder_specifics || "";
    this.responderImageURL = data.responder_imageurl || "";
    this.dateOfCreate = data.date_of_create || "";
  }

  static fromArray(array) {
    return array.map((item) => new Answer(item));
  }
}